$(document).ready(function() {

    cartPopUp();
    fundingAds();
    downloadFIlesAcc();
    wooLoginAcc();
    faqAcc();
    ratingFill();
    // calcServiceFee();
    tableOfContents();
    colorLikes();
    addtimes();
    ldCountComponents();
    sampleCourse();
    // reviewDot();
    productFilter();
    showTopicFiles();
    countMaterial();
    expandCurrentLesson();
    stickySidebarFooterFx();
    showCommentsFormTopic();
    notifications();
    intcountQ();
    stickComment();
    progressCircle();
    startQ();
    markAsComplete();
    memXSubs();
    internalNavPos();
    toggleMemMenu();
    memAccordion();
    meFiles();
    triggerOrderSortBySubmit();
    triggerSubscriptionPlanChange();
    // wooPayBox();
    unSubAll();
    productSlider();
    singleProductForm();
    singleProductAjaxAddToCart();
    subscriptionCartUpdate();
    singleProductSubscriptionPriceUpdate();
    blogSideMenu();
    closeAds();
    multiSelect();
    responsiveComparison();
    fileAcc();
    openInvoiceInNewTab();
    scrollShopPage();
    confProdcCopyPrice();
    expandLessons();
	allLinksInNewTab()

    // IF THE BROWSER IS INTERNET EXPLORER 10
    if (navigator.appVersion.indexOf("MSIE 10") !== -1)
    {
      $("body").addClass('ie10');
    }



});

var wWidth = $(window).width();
$( window ).resize(function() {
  if ($(this).width() !== wWidth) {
    blogSideMenu();
  }
});

window.addEventListener(
  'scroll',
  function (event) {
    intcountQ();
    internalNavPos();
  },
  { passive: true }
);

function fundingAds() {
  $(window).on("load", function () {
    setTimeout(function () {
      $("html").addClass("pp-active");
    }, 10000);
    var slidesCount = $('.js-ads-swipper').data('slides-count');
    new Swiper(".js-ads-swipper", {
      loop: slidesCount > 1,
      watchOverflow: true,
      pagination: {
        el: ".js-ads-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 18000,
      },
      speed: 3000,
      spaceBetween: 10,
    });
  });
  $(".popup-ads .js-pp-close").on("click touch", function (e) {
    $("html").removeClass("pp-active");
  });
}

function setAdsHeight() {
  var height = $(".fq-ad").height();
  $(".js-scrollable").css("max-height", height + 100);
}

function cartPopUp() {
  $(".add_to_cart_button").click(function () {
    var observer = new MutationObserver(function(mutations) {
     mutations.forEach(function(mutation) {
       if (mutation.attributeName === "class") {
         var attributeValue = $(mutation.target).prop(mutation.attributeName);
         if(/added/i.test(attributeValue)){
           $(".cart-notify").addClass("on");
            setTimeout(function() {
              $(".cart-notify").removeClass("on");
            }, 2000);
         }
       }
     });
   });
   observer.observe($(this)[0], {
     attributes: true
   });
 });
}

function updateCartCoupon() {
  $("[name='apply_coupon']").click(function () {
    $(".update-cart").trigger("click");
  });
}

function downloadFIlesAcc() {
    $(".colection-header").toggleClass("open");
    $(".colection-header").next().toggleClass("open");
    var height = $(".colection-header").next().find(".item-wrap").outerHeight();
    if ($(".colection-header").hasClass("open")) {
      $(".colection-header").next().css("height", height);
    } else {
      $(".colection-header").next().css("height", 0);
    }
  $(".file-collection").each(function functionName() {
    var sizeC = 0.0;
    var unit = "MB";
    $(".item", this).each(function () {
      var value = $(this).data("fsize");
      var sizei = value.slice(0, -3);
      unitL = value.substr(value.length - 2);
      size = parseInt(sizei);
      if (unitL == "MB" || unitL == "mB") {
        sizeC += parseFloat(size || 0);
    } else if (unitL == "KB" || unitL == "kB") {
        sizeC += parseFloat(size / 1000 || 0);
      }
    });
    $(this).find(".combo-size").attr("data-combinesize", sizeC.toFixed(1));
  });
  $(".alldown").click(function (e) {
    e.preventDefault();
    var target = $(this).data("group");
    $(".download-single-file[data-group=" + target + "]").each(function (
      i,
      elem
    ) {
      setTimeout(function () {
        $(elem)[0].click();
      }, 2500 * i);
    });
  });
}
function wooLoginAcc() {
  $(".tab-link").click(function () {
    var target = $(this).data("to");

    $(".tab-link").removeClass("active");
    $(this).addClass("active");

    $(".tab-content").removeClass("active");
    $(".tab-content[data-tab=" + target + "]").addClass("active");
  });
}
function faqAcc() {
  $(".faq-title").click(function () {
    var height = $(this).next().find(".inn").outerHeight();
    if ($(this).hasClass("open")) {
      $(".faq-title").removeClass("open");
      $(".faq-answer").removeClass("open");
      $(".faq-answer").css("height", 0);
    } else {
      $(".faq-title").removeClass("open");
      $(".faq-answer").removeClass("open");
      $(this).addClass("open");
      $(this).next().addClass("open");
      $(".faq-answer").css("height", 0);
      $(this).next().css("height", height);
    }
  });
}
function fileAcc() {
  $(".toggle-f-dsc").click(function () {
    var height = $(this).closest(".file-bar").next().find(".inn").outerHeight();
    if ($(this).closest(".fp-item").hasClass("open")) {
        $(".fp-item").removeClass("open");
        $(".file-dsc").css("height", 0);
    } else {
      $(".fp-item").removeClass("open");
      $(this).closest(".fp-item").addClass("open");
      $(".file-dsc").css("height", 0);
      $(this).closest(".file-bar").next().css("height", height);
    }
  });
}
function ratingFill() {
  $(".ser-fdbk-stars__fill").each(function () {
    var num = $(this).data("rating");
    var fill = num * 2 * 10;
    $(this).css("width", fill + "%");
  });
}
function calcServiceFee() {
  $(".ser-calc__btn").click(function () {
    var grant = $(".ser-calc__inp").val();
    if (grant < 3000) {
      $(".calc_err").addClass("show");
      setTimeout(function () {
        $(".calc_err").removeClass("show");
      }, 4000);
    } else {
      var rate = $(this).data("rate");
      var reduce = $(this).data("reduce");
      var multi = $(this).data("multiply");
      var maxAmount = $(this).data("max-amount");
      var fee = rate + multi * (grant - reduce);
      fee = fee > maxAmount ? maxAmount : fee;
      var feeDeci = parseFloat(fee).toFixed(2);
      var fee_de = feeDeci.toString().replace(/\./g, ",");
      if (fee < 1000) {
        $(".calculated").text("1000,00");
      } else {
        $(".calculated").text(fee_de);
      }
    }
  });
}

function tableOfContents() {
    var fqTOC = document.querySelector('.fq-toc');
    var fqTOCExpandAllBtn = document.querySelector('.fq-toc__expand-all-btn');
    if (fqTOC) {
        fqTOC.addEventListener('click', function(e) {
            if ($(e.target).closest('.fq-toc__single__expand')) {
                e.preventDefault();
                e.target.parentNode.parentNode.parentNode.classList.toggle('--expanded');
            }

            if ($(e.target).closest('.fq-toc__single__toc-item__toggle')) {
                e.preventDefault();
                e.target.parentNode.classList.toggle('--expanded');
            }
        });
    }

    if (fqTOCExpandAllBtn) {
        fqTOCExpandAllBtn.addEventListener('click', function(e) {
            e.preventDefault();
            var allTOCItems = document.getElementsByClassName('fq-toc__single');
            var allTOPSubitems = document.getElementsByClassName('fq-toc__single__toc-item');

            if (this.classList.contains('--expanded')) {
                for (var i = 0; i < allTOCItems.length; i++) {
                    allTOCItems[i].classList.remove('--expanded');
                    this.classList.remove('--expanded');
                }

                for (var i = 0; i < allTOPSubitems.length; i++) {
                    allTOPSubitems[i].classList.remove('--expanded');
                }
            } else {
                for (var i = 0; i < allTOCItems.length; i++) {
                    allTOCItems[i].classList.add('--expanded');
                    this.classList.add('--expanded');
                }

                for (var i = 0; i < allTOPSubitems.length; i++) {
                    allTOPSubitems[i].classList.add('--expanded');
                }
            }
        });
    }
    if ($('.fq-ld-app').length ) {
    var fqLdApp = $('.fq-ld-app');

    $('.fq-ld-app__sidebar__close').click(function () {
      fqLdApp.addClass('sidebar-closed');
    })
    $('.fq-ld-app__sidebar__open').click(function () {
      fqLdApp.removeClass('sidebar-closed');
    })

    $('.fq-ld-app__lesson-single__toggle').click(function () {
      $('.fq-ld-app__lesson-single').removeClass('expanded')
      $(this).closest('.fq-ld-app__lesson-single').toggleClass('expanded');
    })
    }
}

function colorLikes() {
  $('.ivole-voting-cont span:first-child').each(function(){
     var line = $(this);
     var firstWord = $(this).text().split(' ')[0];
     if (firstWord === 'War') {
     }else {
       if(firstWord === '1'){
         line.html(line.html().replace(/^(\w+)/, '<span class="clr sng">$1</span>'));
       }else{
         line.html(line.html().replace(/^(\w+)/, '<span class="clr">$1</span>'));
       }
       $(this).addClass('hide-txt')
     }

   });
   $(".li.reviews_tab a").click(function (e) {
     e.preventDefault()
   })
}

function colorLikes() {
  $(".ivole-voting-cont span:first-child").each(function () {
    var line = $(this);
    var firstWord = $(this).text().split(" ")[0];
    if (firstWord === "War") {
    } else {
      if (firstWord === "1") {
        line.html(
          line.html().replace(/^(\w+)/, '<span class="clr sng">$1</span>')
        );
      } else {
        line.html(line.html().replace(/^(\w+)/, '<span class="clr">$1</span>'));
      }
      $(this).addClass("hide-txt");
    }
  });
  $(".li.reviews_tab a").click(function (e) {
    e.preventDefault();
  });
}
$(document.body).on("init", function () {
  // FU woocomerce
  $("html, body").stop();
});
function addtimes() {
  $(".ld-item-list#course,.count-duration").each(function () {
    var timesb = [0, 0, 0];
    $(this)
      .find(".ld-item-list-item")
      .each(function () {
        var a = "";
        var times = [0, 0, 0];
        var max = times.length;
        $(this)
          .find(".ld-table-list-item")
          .each(function (i) {
            var time = $(this).data("duration");
            var a = (time || "").split(":");
            for (var i = 0; i < max; i++) {
              a[i] = isNaN(parseInt(a[i])) ? 0 : parseInt(a[i]);
            }
            for (var i = 0; i < max; i++) {
              times[i] += a[i];
            }
          });
        var hours = times[0];
        var minutes = times[1];
        var seconds = times[2];

        if (seconds >= 60) {
          var m = (seconds / 60) << 0;
          minutes += m;
          seconds -= 60 * m;
        }

        if (minutes >= 60) {
          var h = (minutes / 60) << 0;
          hours += h;
          minutes -= 60 * h;
        }
        var tots =
          ("0" + hours).slice(-2) +
          ":" +
          ("0" + minutes).slice(-2) +
          ":" +
          ("0" + seconds).slice(-2);
        var timeb = tots;
        var b = (timeb || "").split(":");
        for (var i = 0; i < max; i++) {
          b[i] = isNaN(parseInt(b[i])) ? 0 : parseInt(b[i]);
        }

        for (var i = 0; i < max; i++) {
          timesb[i] += b[i];
        }

        $(this).find(".ld-item-components").append("<span class='ld-sep'>|</span><span class='tot-dur'>" + tots + "</span>");
      });
    var hoursb = timesb[0];
    var minutesb = timesb[1];
    var secondsb = timesb[2];

    if (secondsb >= 60) {
      var mb = (secondsb / 60) << 0;
      minutesb += mb;
      secondsb -= 60 * mb;
    }

    if (minutesb >= 60) {
      var hb = (minutesb / 60) << 0;
      hoursb += hb;
      minutesb -= 60 * hb;
    }
    var totsb =
      ("0" + hoursb).slice(-2) +
      ":" +
      ("0" + minutesb).slice(-2) +
      ":" +
      ("0" + secondsb).slice(-2);
    $(this)
      .find(".abs-duration")
      .prepend("<span class='all tot-dur'>" + totsb + "</span>");
  });
}

function ldCountComponents() {
  $(".wrapup").each(function () {
    var numberT = 0;
    var numberQ = 0;
    $(this)
      .find(".topics-x")
      .each(function (i) {
        numberT = parseInt($(this).text().split(" ")[1]);
        numberT += numberT;
      });
    $(this)
      .find(".quizzes-x")
      .each(function (n) {
        numberQ = parseInt($(this).text().split(" ")[0]);
        if (n > 1) {
          numberQ += numberQ;
        }
      });
    $(this)
      .find(".ld-lesson-section-heading")
      .append(
        "<span class='tot-less'>" +
          numberT +
          " Themen</span><span class='tot-qzz'>" +
          numberQ +
          "</span>"
      );
  });
}

function sampleCourse() {
  $(".single-product .ld-item-list-item-preview").each(function () {
    if ($(this).find("video").length !== 0) {
      var htmlVid = $(this).find("video source").attr("src");
      $(this)
        .find(".init-popup")
        .click(function (e) {
          var lightbox = lity(
            '<div class="lbox-hold"><video controls="controls" width="100%" height="52.6%"><source src="' +
              htmlVid +
              '" type="video/mp4"></video></div>'
          );
        });
    }
    if ($(this).find("iframe").length !== 0) {
      var yVid = $(this).find("iframe").attr("src");
      $(this)
        .find(".init-popup")
        .click(function (e) {
          var lightbox = lity(
            '<div class="lbox-hold"><div class="ser-pres__video"><iframe  width="640" height="360" src="' +
              yVid +
              '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe></div></div>'
          );
        });
    }
    if ($(this).find(".rll-youtube-player").length !== 0) {
      var yVidlazy = $(this).find(".rll-youtube-player").data("id");
      $(this)
        .find(".init-popup")
        .click(function (e) {
          var lightbox = lity(
            '<div class="lbox-hold"><div class="ser-pres__video"><iframe  width="640" height="360" src="https://www.youtube.com/embed/' +
              yVidlazy +
              '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe></div></div>'
          );
        });
    }
    if($(this).find('.rll-vimeo-player').length !== 0){
      var yVidlazy = $(this).find('.rll-vimeo-player').data('id');
      $(this).find('.init-popup').click(function (e) {
        var lightbox = lity('<div class="lbox-hold"><div class="ser-pres__video"><iframe src="https://player.vimeo.com/video/'+yVidlazy+'" width="" height="" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div></div>');
      })
    }
  });
  $(".single-product .ld-table-list-item").each(function () {
    if ($(this).find("video").length !== 0) {
      var htmlVid = $(this).find("video source").attr("src");
      $(this)
        .find(".init-popup")
        .click(function (e) {
          var lightbox = lity(
            '<div class="lbox-hold"><video controls="controls" width="100%" height="52.6%"><source src="' +
              htmlVid +
              '" type="video/mp4"></video></div>'
          );
        });
    }
    if ($(this).find("iframe").length !== 0) {
      var yVid = $(this).find("iframe").attr("src");
      $(this)
        .find(".init-popup")
        .click(function (e) {
          var lightbox = lity(
            '<div class="lbox-hold"><div class="ser-pres__video"><iframe  width="640" height="360" src="' +
              yVid +
              '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe></div></div>'
          );
        });
    }
    if ($(this).find(".rll-youtube-player").length !== 0) {
      var yVidlazy = $(this).find(".rll-youtube-player").data("id");
      $(this)
        .find(".init-popup")
        .click(function (e) {
          var lightbox = lity(
            '<div class="lbox-hold"><div class="ser-pres__video"><iframe  width="640" height="360" src="https://www.youtube.com/embed/' +
              yVidlazy +
              '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe></div></div>'
          );
        });
    }
    if($(this).find('.rll-vimeo-player').length !== 0){
      var vimeoVidlazy = $(this).find('.rll-vimeo-player').attr('id');
      $(this).find('.init-popup').click(function (e) {
        var lightbox = lity('<div class="lbox-hold"><div class="ser-pres__video"><iframe src="https://player.vimeo.com/video/'+vimeoVidlazy+'" width="" height="" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div></div>');
      })
    }
  });
}

// function reviewDot() {
//   $(".ser-fdbk__text span").each(function () {
//     var text = $(this).text().toString().replace(/\./g, ",");
//     $(".ser-fdbk__text span").empty();
//     $(".ser-fdbk__text span").text(text);
//   });
// }

function productFilter() {
  $(window).on("load", function () {
    $(document)
      .find(".berocket_single_filter_widget .hide_button")
      .trigger("click");
  });
  $(".js-toggle-product-filter").click(function (e) {
    e.preventDefault();
    $("#product-filter").toggleClass("product-filter-closed");
  });
}

function showTopicFiles() {
  $(".nxt .open_files").click(function () {
    var openHeight = $(this).next().find(".inn").outerHeight();
    $(".open_files").next().css("height", 0);
    $(".open_files").removeClass('open');
    if($(this).next().length){
        if ($(this).hasClass("open")) {
          $(this).removeClass("open");
          $(this).next().css("height", 0).removeClass('open');
        } else {
          $(this).addClass("open");
          $(this).next().css("height", openHeight).addClass('open');
        }
    }
  });
  $(".chapter-topics .topic").click(function () {
    var openHeight = $(this).next().find(".topic-subs").outerHeight();
    var parent = $(this).closest('.chapter-topics')
    var parentHeight = parent.outerHeight();
    if($(this).next().length){
        if ($(this).hasClass("open")) {
          $(this).removeClass("open");
          $(this).next().css("height", 0).removeClass('open');
          parent.css("height", (parentHeight - openHeight))
        } else {
          parent.css("height", (openHeight + parentHeight))
          $(this).addClass("open");
          $(this).next().css("height", openHeight).addClass('open');
        }
    }
  });
}
function countMaterial() {
  $("#materials").each(function () {
    var c = 0;
    var n = "Dateien";
    $(this)
      .find(".downloadit")
      .each(function () {
        c++;
      });
    if (c < 2) {
      n = "Datei";
    }
    $(this)
      .find(".numFiles")
      .html(c + " " + n);
      if(c < 1){
          $(".ld-tab[data-ld-tab='materials']").addClass('no-files')
      }
  });
  $(".fq-ld-app__materials__dl-all").click(function () {
    $(".downloadit").each(function () {
      $(this).trigger("click");
    });
  });
}

function expandCurrentLesson() {
  $(".fq-ld-app__topic-single").each(function () {
    if($(this).hasClass('expanded-par')){
      $(this).closest('.fq-ld-app__lesson-single').addClass('expanded')
    }
  });
  $(".fq-ld-app__lesson-single a").click(function (e) {
      e.preventDefault();
  })
}

function stickySidebarFooterFx() {
  var sidebar = $('.fq-ld-app__sidebar');
  var footer = $('.site-pre-footer');
  window.addEventListener(
    'scroll',
    function (event) {
      var bottom = footer.offset().top - $(window).height();
      var windowTop = $(this).scrollTop();
      if (windowTop > bottom) {
        sidebar.css({ bottom: windowTop - bottom });
      } else {
        sidebar.css({ bottom: 0 });
      }
    },
    { passive: true }
  );
}

function showCommentsFormTopic() {
  $(".show-form").click(function () {
    $(".wpd-form-wrap").toggleClass("open");
  });
}
function notifications() {
  $(".ld-spec").click(function () {
    $(".ld-tab").removeClass("ld-active");
    $(this).addClass("ld-active");
    $("#ld-tab-discussion").addClass("notify");
  });
  $(".ld-tab").click(function () {
    if ($(this).hasClass("ld-spec")) {
    } else {
      $(".ld-spec").removeClass("ld-active");
      $("#ld-tab-discussion").removeClass("notify");
    }
  });
}

function countQ() {
  var qs = $(".wpd_comment_level-1").length;
  var ns = $(".wpd-sticky-comment").length;

  $(".q-qount").text(qs);
}

function progressCircle() {
  $(".progress-graph").each(function functionName() {
    var prog = $(this).data("progresnum") / 100;
    var perc = 125.64 * (1 - prog);
    $(this).find(".progress-stroke").css({ "stroke-dashoffset": perc });
  });
}
function intcountQ() {
  setTimeout(function () {
    countQ();
  }, 2000);
  setTimeout(function () {
    countQ();
  }, 3000);
}
function stickComment() {
  var target = $(
    '.wc-field-submit .wpd_label[wpd-tooltip="Stick this comment"]'
  );

  $('.ld-tab[data-spec="notifications"]').click(function () {
    if (!target.hasClass("on")) {
      target.trigger("click").addClass("on");
    }
  });
  $('.ld-tab[data-spec="discussion"]').click(function () {
    if (target.hasClass("on")) {
      target.trigger("click").removeClass("on");
    }
  });
}
function startQ() {
  $(".start-cs").click(function () {
    $(".ld-item-list-items").find(".ld-item-name").trigger("click");
  });
}
function markAsComplete() {
  $(".ld-content-action.next a:not(.completed)").click(function (e) {
    e.preventDefault();
    $(this).addClass('waitcursor')
    $(".learndash_mark_complete_button").trigger('click').addClass('clicked')
  })
}

function memXSubs() {
  $(".internal-nav .topl").click(function (e) {
    $(".internal-nav>a, .internal-nav>nav").removeClass("expanded");
    $(this).addClass("expanded");
    $(this).next().addClass("expanded");
    e.preventDefault();
     var target = $(this).attr('href');
     $('html, body').animate({
         scrollTop: ($(target).offset().top - 100)
     }, 2000);
  });
  $(".internal-nav .sub a").click(function (e) {
    $(".internal-nav a, .internal-nav nav, .internal-nav").removeClass("manualy-expanded");
    $(this).addClass("manualy-expanded");
    $(this).closest(".sub").addClass("manualy-expanded");
    $(".internal-nav").addClass("manualy-expanded");
    setTimeout(function () {
      $(".internal-nav a, .internal-nav nav, .internal-nav").removeClass("manualy-expanded");
    }, 2000);
    e.preventDefault();
     var target = $(this).attr('href');
     $('html, body').animate({
         scrollTop: ($(target).offset().top - 100)
     }, 1000);
  });
  $(".internal-nav>a").mouseenter(function () {
    $(this).next().addClass("expanded");
  })
}

function internalNavPos() {
  var $sections = $(".track-chapter");
  var currentScroll = $(window).scrollTop();
  var centerVar = $(window).height() / 3;
  var $currentSection;

  $sections.each(function () {
    var divPosition = $(this).offset().top - centerVar;
    if (divPosition - 1 < currentScroll) {
      $currentSection = $(this);
      var id = $currentSection.attr("id");
      $("a").removeClass("expanded");
      $(".sub").removeClass("expanded");
      $(".sub-sub").removeClass("expanded");
      $("[href=\\#" + id + "]").addClass("expanded");
      // $("[href=\\#" + id + "]").closest(".sub").addClass("expanded");
      // $("[href=\\#" + id + "]").closest(".sub-2").addClass("expanded");
      // if ($("[href=\\#" + id + "]").hasClass("sub-a")) {
      //   $("[href=\\#" + id + "]").closest(".sub-sub").addClass("expanded");
      // }

      var  bodyHeight = $("body").height();
      var  bodyScroll = $(document).scrollTop();
      var  navHeightInternal = $(".nav-test").height();
      var  scrollAmm = (bodyScroll / (bodyHeight / navHeightInternal))
      $(".internal-nav").scrollTop(scrollAmm - 150)

      // var pos = $("[href=\\#" + id + "]").offset();
      // if (pos !== undefined){
      //
      //
      //     // console.log(pos.top);
      //     var amm = $(".internal-nav").scrollTop() + (pos.top) - $("body").scrollTop() - $(".internal-nav")/2 + 10;
      //     console.log(amm);
      //     $(".internal-nav").scrollTop(amm)
      // }



      // $parentDiv.scrollTop($parentDiv.scrollTop() + $innerListItem.position().top - $parentDiv.height()/2 + $innerListItem.height()/2);
    }
  });
}

function centerSideMenuItems() {

}

function toggleMemMenu() {
  $(".membership-container .toggle-menu").click(function () {
    $(".membership-container").toggleClass("menu-on");
  });
}

function memAccordion() {
  $(".accordion-title").click(function () {
    var height = $(this).next().find(".inn").outerHeight();
    if ($(this).hasClass("open")) {
      $(this).next().css("height", 0);
      $(this).removeClass("open");
      $(this).closest(".accordion-item").removeClass("open");
    } else {
      $(".accordion-item").removeClass("open");
      $(".accordion-title").removeClass("open");
      $(".accordion-content").css("height", 0);
      $(this).addClass("open");
      $(this).closest(".accordion-item").addClass("open");
      $(this).next().css("height", height);
    }
  });
}
function meFiles() {
  $(".bp-link").click(function (e) {
    e.stopPropagation();
  });
  $(".expand-files.contents").click(function () {
    $(".file-contents").toggleClass("hide");
  });
  $(".file-contents.nxt .title-file").click(function () {
      $(".file-contents").toggleClass("hide");
  })
  $(".down-all").click(function (e) {
    e.preventDefault();
    var findId = $(this).data("id");
    $('[data-trg="' + findId + '"]').each(function (i, elem) {
      setTimeout(function () {
        $(elem)[0].click();
      }, 2500 * i);
    });
  });
}

$(document).on("click", ".berocket_aapf_widget-title_div", function (e) {
  $(".berocket_single_filter_visible .berocket_aapf_widget-title_div")
    .not($(this))
    .find(".berocket_aapf_widget_show")
    .trigger("click");
});
$(document).on("click", ".berocket_aapf_widget_show", function () {
  $(".berocket_single_filter_visible .berocket_aapf_widget_show")
    .not(this)
    .trigger("click");
});

function triggerOrderSortBySubmit() {
  $(".js-order-sort-by").on("change", function () {
    $(this).closest("form").submit();
  });
}

function triggerSubscriptionPlanChange() {
  $(".js-product-plans .wcsatt-options-product .subscription-option input").on(
    "change",
    function () {
      $(
        'form.cart input[name="' +
          $(this).attr("name") +
          '"][value="' +
          $(this).attr("value") +
          '"]'
      ).trigger("click");
    }
  );
}

// function wooPayBox() {
//   // var paybox = $(".wc_payment_method.active .payment_box");
//   // var stripeH = paybox.outerHeight();
//   // $(".wc_payment_method.payment_method_paypal").addClass('active');
//   // $(".wc_payment_methods").css(
//   //   "padding-bottom",
//   //   stripeH + 60
//   // );
//   // $('.wc_payment_method').click(function () {
//   //   var stripeHeight = $(this).find('.payment_box').outerHeight();
//   //   $('.wc_payment_method').removeClass('active');
//   //   $(this).addClass('active');
//   //   $(".wc_payment_methods").css(
//   //     "padding-bottom",
//   //     stripeHeight + 60
//   //   );
//   // })
// }
// function wooPayBox2() {
//
//   $('.wc_payment_method').click(function () {
//     var stripeHeight = $(this).find('.payment_box').outerHeight();
//     console.log(stripeHeight);
//     $('.wc_payment_method').removeClass('active');
//     $(this).addClass('active');
//     $(".wc_payment_methods").css(
//       "padding-bottom",
//       stripeHeight + 60
//     );
//   })
// }
// $(document).on('clcik', ".wc_payment_method input[type=radio]",wooPayBox);
// $("body").on("DOMSubtreeModified", ".wc_payment_method",function () {
//     console.log("mod");
//         wooPayBox2();
// });

function unSubAll() {
  $("#fue_unsubscribe_all").trigger('click');
}
// berockets $script
jQuery(document).on("berocket_aapf_time_to_fix_products_style", function() {
                jQuery(the_ajax_script.products_holder_id).find("*").filter(function() {return jQuery(this).css("opacity") == "0";}).css("opacity", 1);
            });

function productSlider() {
  $(window).on('load', function() {
    var galleryThumbs = new Swiper('.gallery-thumbs', {
      spaceBetween: 0,
      slidesPerView: 3,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      autoplay: false,
      watchOverflow: true,
    });
    var galleryTop = new Swiper('.gallery-top', {
      spaceBetween: 0,
      autoplay: false,
      watchOverflow: true,
      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // },
      thumbs: {
        swiper: galleryThumbs,
      }
    });
    galleryTop.on('slideChange', function () {
      $(".gallery-top .swiper-slide iframe").each(function () {
        $(this).attr("src", $(this).attr("src"));
      })
      var currentIndex = $(this)[0].activeIndex;
      var previousIndex = $(this)[0].previousIndex;
      if ((currentIndex >=2 && currentIndex > previousIndex) || (currentIndex >=1 && currentIndex < previousIndex)) {
        galleryThumbs.slideTo(currentIndex - 1, 300, false)
      }
    });
  });
}

function singleProductForm() {
  $(document).on( 'frmFormComplete', function( event, form, response ) {
    if ($('.single-product .js-form-single-product .frm_message .js-eligible').length > 0) {
      $('.single-product .js-form-single-product .js-form-button-wrap').show();
    }
    $('.single-product .js-form-single-product .js-reload').show();
  });
}

function singleProductAjaxAddToCart() {
  // Trigger event for adding the product to cart with the hidden original button
  $('.js-trigger-add-to-cart').on('click', function(e) {
    e.preventDefault();
    $('.product-options .single_add_to_cart_button').trigger('click');
  });

  $('.single-product form.cart').on('submit', function(e) {
    e.preventDefault();
    // Ajax add to cart on the product page
    var $warp_fragment_refresh = {
      url: wc_cart_fragments_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_refreshed_fragments' ),
      type: 'POST',
      success: function( data ) {
          if ( data && data.fragments ) {

              $.each( data.fragments, function( key, value ) {
                  $( key ).replaceWith( value );
              });

              $( document.body ).trigger( 'wc_fragments_refreshed' );
          }
      }
    };
    var product_url = window.location;
    var form = $(this);
    form.block({ message: null, overlayCSS: { background: '#fff', opacity: 0.6 } });

    $('.js-trigger-add-to-cart').addClass('loading');
    var formData = 'add-to-cart=' + form.find('[name=add-to-cart]').val();
    formData = formData + '&' + form.serialize();
    // Ajax action.
    $.post(product_url, formData + '&_wp_http_referer=' + product_url, function (response) {
      $.ajax($warp_fragment_refresh);
      // Remove existing notices
      $( '.woocommerce-notices-wrapper' ).remove();
      var woocommerce_message = $('.woocommerce-notices-wrapper', response);
      // Show message
      $('.type-product').eq(0).before(woocommerce_message);

      // Add class for custom trigger button
      $('.js-trigger-add-to-cart').removeClass('loading');
      $('.js-trigger-add-to-cart').addClass('added');

      form.unblock();
    });
  });
}

function subscriptionCartUpdate() {
  $(document).on('change', '.woocommerce-cart .wcsatt-options input[type="radio"]', function() {
    $(document).find('button[name="update_cart"]').trigger('click');
  });
}

function singleProductSubscriptionPriceUpdate() {
  $('.single-product .wcsatt-options-product input[type="radio"]').on('change', function() {
    if ($(this).val() === "0" || $(this).closest('.subscription-option').find('.subscription-price').hasClass('no-price')) {
      var currentPrice = $('.js-current-price').html();
      $('.js-toggle-price').html(currentPrice);
    } else {
      var currentPrice = $(this).closest('.subscription-option').find('.woocommerce-Price-amount');
      currentPrice = currentPrice.length > 1 ? currentPrice[1].innerHTML : currentPrice[0].innerHTML;
      $('.js-toggle-price').html(currentPrice);
    }
  });
  // Trigger change for price when page loads
  $('.single-product .wcsatt-options-product input[type="radio"]:checked').trigger('change');
}
function blogSideMenu() {
  var screenSize = $(window).width();
  if(screenSize < 1025){
    $(".membership-container").removeClass('menu-on')
    $(".mem-content-section").click(function () {
      $(".membership-container").removeClass('menu-on');
    });
    $(".list-fundings").click(function () {
      $(".membership-container").removeClass('menu-on');
    });
  }else{
    $(".membership-container").addClass('menu-on')
  }
}
function closeAds() {
  $(".close-ads").click(function () {
    $(this).parent().addClass('closed-ads')
  })
}
function multiSelect() {
  $('select[multiple=multiple] option').mousedown(function(e) {
    e.preventDefault();
    $(this).prop('selected', !$(this).prop('selected'));
    return false;
  });
}
function responsiveComparison() {
	$('.fq-fct').each(function(){
	  var prodOne = $(this).find('th:nth-child(2)').text();
	  var prodTwo = $(this).find('th:nth-child(3)').text();
	  $(this).find('tr').each(function(){
		$(this).find('td:nth-child(2)').attr("data-product", prodOne);
		$(this).find('td:nth-child(3)').attr("data-product", prodTwo);
	  })
	})
  }


function openInvoiceInNewTab() {
  $('.js-invoice-download a').attr('target', '_blank');
}

function scrollShopPage() {
    $(".page-numbers a").click(function () {
        $("html, body").animate({ scrollTop: 0 }, "slow");
    })
}

function confProdcCopyPrice() {
    var isOnLoad = true;
    $(document).on('change', '.configurable-container .product-options', function() {
      var calculated  = $(".single-product .fp-product-addon-amount").text();
      var remSym = calculated.slice(0,-1);
      var addedCurr = remSym.concat("EUR");
      $(".fp-product-addon-label").empty();
      if (!isOnLoad) {
        $(".js-pr-ab").empty();
      }
      $(".fp-product-addon-label").append('<span class="newFdqPrice">' + (isOnLoad ? 'ab ' : '') + addedCurr + '</span>');
      $(".ser-pres__price__ammount .woocommerce-Price-amount bdi").empty().append(remSym);
    });
    $(window).on('load', function() {
      isOnLoad = false;
    })
}

function expandLessons() {
    $(window).on("load", function () {
        $(".ld-expand-button").each(function () {
            $(this).trigger("click");
        })
        $(".single-product .ld-expand-button").each(function () {
            $(this).trigger("click");
        })
    })

}

function allLinksInNewTab() {
	$(".list-fundings a, .frm_show_file_icon .frm_upload_label a").each(function () {
		var linkUrl = $(this).attr('href');
		$(this).on("click",function(e){
			e.preventDefault();
			window.open(linkUrl,'_blank');
		});
	})
	
}
